import React from "react"

import { gql, useQuery } from "urql"

import { AlertLevel } from "~tailwindui/types/enums"

import { AlertMessageBox, H2, WithLoadingIndicator } from "~tailwindui/Basics"

import ordered from "src/ordered"

import SectionCard from "./SectionCard"

const CourseSectionRegistration = () => {
  const [result] = useQuery({ query: courseClustersQuery })

  return (
    <div>
      <AlertMessageBox level={AlertLevel.Info}>
        When a new scheduled program is created, available groups will appear
        here.
      </AlertMessageBox>

      <WithLoadingIndicator result={result}>
        {({ data: { viewer } }) => (
          <>
            {viewer.recentlyGaveUpGroup ? (
              <AlertMessageBox level={AlertLevel.Warning}>
                You have given up a study group in the last 48 hours, so you are
                ineligible to accept new groups at this time.
              </AlertMessageBox>
            ) : null}

            {viewer.registerableCourseClusters.length === 0 ? (
              <span className="mt-8 text-lg italic">
                No courses available to register for at this time.
              </span>
            ) : (
              <>
                <H2>Registerable Course Sections</H2>
                <div className="flex flex-wrap gap-10">
                  {viewer.registerableCourseClusters.map(
                    cluster =>
                      ordered(
                        cluster.tutorRegisterableCourseSections.map(section => (
                          <SectionCard
                            key={section.id}
                            courseCluster={cluster}
                            courseSection={section}
                          />
                        ))
                      ),
                    "startsOn"
                  )}
                </div>
              </>
            )}
          </>
        )}
      </WithLoadingIndicator>
    </div>
  )
}

const courseClustersQuery = gql`
  query RegisterableCourseClusters {
    viewer {
      recentlyGaveUpGroup
      foreignLanguages {
        id
      }
      registerableCourseClusters {
        id
        name
        description
        subject {
          id
          name
        }
        grades {
          id
          name
          number
        }
        tutorRegisterableCourseSections {
          id
          startsOn
          endsOn
          maxSubsEstimate
          organization {
            minTutorConsistencyRate
            name
            details
            emailTimeZone
          }
          availabilities {
            id
            startsAt
            endsAt
            weekday
            duration
          }
        }
      }
    }
  }
`

export default CourseSectionRegistration
